/* HomeStyles.js */
import styled from 'styled-components';

export const MainContainer = styled.div`
  text-align: center;
  padding: 20px;
  border-bottom-left-radius:60px;
  border-bottom-right-radius:60px;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.h1`
  color: #9c27b0;
  font-size: 2em;
`;

export const Subtitle = styled.h2`
  color: #333;
  font-size: 1.5em;
`;

export const Description = styled.p`
  color: #555;
  font-size: 1em;
`;

export const ButtonContainer = styled.div`
  margin-top: 20px;
`;

export const MainButton = styled.button`
  background-color: #e91e63;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
  margin: 0 5px;

  &:hover {
    background-color: #d81b60;
  }
`;

export const SecondaryButton = styled(MainButton)`
  background-color: #1a202c;

  &:hover {
    background-color: #2d3748;
  }
`;

export const Image = styled.img`
  width: 50%;
  margin-top: 20px;
`;
